import { ModuleUser } from 'app/library/module-user/models/module-user.model';

export class UpdateModuleResponsibleManager {
    static readonly type = '[Module] UpdateModuleResponsibleManager';

    constructor(public payload: ModuleUser[]) {}
}
